module.exports = __webpack_public_path__ + "static/ceremony-horiz-bf1ed2e0e34a432307886639b35f18fa.jpg";